import { render, staticRenderFns } from "./ItemEdit.vue?vue&type=template&id=2d6fefc4&scoped=true"
import script from "./ItemEdit.vue?vue&type=script&lang=js"
export * from "./ItemEdit.vue?vue&type=script&lang=js"
import style0 from "./ItemEdit.vue?vue&type=style&index=0&id=2d6fefc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6fefc4",
  null
  
)

export default component.exports